import React from 'react';

const EventSelector = ({ 
  events, 
  selectedEvent, 
  selectedSection, 
  onEventChange, 
  onSectionChange 
}) => {
  // Debug logging
  console.log('🔍 EventSelector: Received events:', events);
  console.log('🔍 EventSelector: Events count:', events?.length || 0);
  console.log('🔍 EventSelector: Selected event:', selectedEvent);
  console.log('🔍 EventSelector: Selected section:', selectedSection);
  const handleEventSelect = (e) => {
    console.log('🔄 EventSelector: Event selected:', e.target.value);
    const eventId = parseInt(e.target.value);
    const event = events.find(event => event.id === eventId);
    console.log('🔍 EventSelector: Found event:', event);
    console.log('🔍 EventSelector: Event sections:', event?.sections);
    onEventChange(event || null);
  };

  const handleSectionSelect = (e) => {
    console.log('🔄 EventSelector: Section selected:', e.target.value);
    const sectionId = parseInt(e.target.value);
    const section = selectedEvent?.sections?.find(section => section.id === sectionId);
    console.log('🔍 EventSelector: Found section:', section);
    onSectionChange(section || null);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Event Selection */}
      <div>
        <label htmlFor="event-select" className="block text-sm font-medium text-gray-700 mb-2">
          Select Event *
        </label>
        <select
          id="event-select"
          value={selectedEvent?.id || ''}
          onChange={handleEventSelect}
          className="block w-full border border-gray-300 rounded-md px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">-- Choose an Event --</option>
          {events.map(event => (
            <option key={event.id} value={event.id}>
              {event.event_name}
              {event.venue && ` (${event.venue})`}
            </option>
          ))}
        </select>
        {events.length === 0 && (
          <p className="text-sm text-gray-500 mt-1">No events available</p>
        )}
      </div>

      {/* Section Selection */}
      <div>
        <label htmlFor="section-select" className="block text-sm font-medium text-gray-700 mb-2">
          Select Section *
        </label>
        <select
          id="section-select"
          value={selectedSection?.id || ''}
          onChange={handleSectionSelect}
          disabled={!selectedEvent || !selectedEvent.sections || selectedEvent.sections.length === 0}
          className="block w-full border border-gray-300 rounded-md px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
          <option value="">-- Choose a Section --</option>
          {selectedEvent?.sections?.map(section => (
            <option key={section.id} value={section.id}>
              {section.section_name || `Section ${section.id}`}
              {section.lecturer && ` - ${section.lecturer}`}
              {` (${new Date(section.start_at).toLocaleString()})`}
            </option>
          ))}
        </select>
        {!selectedEvent && (
          <p className="text-sm text-gray-500 mt-1">Select an event first</p>
        )}
        {selectedEvent && (!selectedEvent.sections || selectedEvent.sections.length === 0) && (
          <p className="text-sm text-gray-500 mt-1">No sections available for this event</p>
        )}
      </div>
    </div>
  );
};

export default EventSelector;
